import React, { useState } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import HeroSection from '../components/HeroSection';
import GallerySection from '../components/GallerySection';
import ActivitiesSection from '../components/ActivitiesSection';
import ReviewsSection from '../components/ReviewsSection';
import SocialMarquee from '../components/SocialMarquee';
import AboutSection from '../components/AboutSection';
import RoomsSection from '../components/RoomsSection';
import CorporateSection from '../components/CorporateSection';
import NearbySection from '../components/NearbySection';
import ContactSection from '../components/ContactSection';
import WhatsAppButton from '../components/WhatsAppButton';
import SplashScreen from '../components/SplashScreen';

const HomePage = () => {
  const [videoReady, setVideoReady] = useState(false);

  React.useEffect(() => {
    const timer = setTimeout(() => setVideoReady(true), 6000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="min-h-screen bg-[#F6F5EF]">
      <SplashScreen isReady={videoReady} />
      <Header />
      <HeroSection onVideoReady={() => setVideoReady(true)} />
      <GallerySection />
      <ActivitiesSection />
      <ReviewsSection />
      <SocialMarquee />
      <AboutSection />
      <RoomsSection />
      <CorporateSection />
      <NearbySection />
      <ContactSection />
      <Footer />
      <WhatsAppButton />
    </div>
  );
};

export default HomePage;
